"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _IntegrationSetup = _interopRequireDefault(require("@insided/deprecated-control/integrations/IntegrationSetup"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _PanelItems = require("@insided/deprecated-control/integrations/components/PanelItems");

var _clipboard = _interopRequireDefault(require("@insided/deprecated-utils/clipboard"));

var _axios = _interopRequireDefault(require("axios"));

var _Tabs = require("@insided/deprecated-control/integrations/components/bi-tools-connector/Tabs");

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _UninstallModal = _interopRequireDefault(require("./components/UninstallModal"));

var _NotificationsTab = _interopRequireDefault(require("@insided/deprecated-control/integrations/components/bi-tools-connector/NotificationsTab"));

var _BiConnectorOverviewDescriptionText = _interopRequireDefault(require("@insided/deprecated-control/integrations/components/bi-tools-connector/BiConnectorOverviewDescriptionText"));

var _biConnectorUtils = require("@insided/deprecated-control/integrations/components/bi-tools-connector/biConnectorUtils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var messageMap = {
  id: 'Access key ID is copied to your clipboard.',
  secret: 'Secret access key is copied to your clipboard.'
};

var BiToolsConnector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(BiToolsConnector, _Component);

  var _super = _createSuper(BiToolsConnector);

  function BiToolsConnector() {
    var _this$props$isInstall, _this$props$accessKey;

    var _this;

    (0, _classCallCheck2.default)(this, BiToolsConnector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isInstalled: (_this$props$isInstall = _this.props.isInstalled) !== null && _this$props$isInstall !== void 0 ? _this$props$isInstall : false,
      credentials: {
        id: (_this$props$accessKey = _this.props.accessKeyId) !== null && _this$props$accessKey !== void 0 ? _this$props$accessKey : ''
      },
      activeTab: 0,
      showUninstallModal: false,
      requestState: {
        type: 'success',
        title: '',
        message: ''
      },
      notificationTabKey: 'notification',
      targets: []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dismissMessage", function () {
      _this.setState({
        messageType: undefined,
        message: ''
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClickUninstallButton", function () {
      _this.setState({
        showUninstallModal: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setActiveTab", function (selectedTab) {
      _this.setState({
        activeTab: selectedTab
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUninstall", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var successMessage, errorMessage;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              successMessage = "You've revoked the access keys successfully.";
              errorMessage = 'Sorry, something went wrong, please try again.';
              _context.prev = 2;
              _context.next = 5;
              return _axios.default.delete('/integration/bitoolsconnector/uninstall');

            case 5:
              _this.setState({
                isInstalled: false,
                credentials: undefined,
                showUninstallModal: false,
                messageType: 'success',
                message: successMessage
              });

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);

              _this.setState({
                messageType: 'error',
                message: errorMessage,
                showUninstallModal: false
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 8]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeUninstallModal", function () {
      _this.setState({
        showUninstallModal: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onGenerateAccessKeys", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var successMessage, errorMessage, moderatorId, result, _result$data, accessKeyId, secretAccessKey;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                messageType: undefined,
                isLoading: true
              });

              successMessage = 'All set! Access keys generated successfully.';
              errorMessage = 'Sorry, something went wrong, please try again.';
              moderatorId = (0, _insidedDataStorage.getInsidedData)('user').userid;
              _context2.prev = 4;
              _context2.next = 7;
              return _axios.default.post('/integration/bitoolsconnector/install', {
                moderatorId: moderatorId
              });

            case 7:
              result = _context2.sent;
              _result$data = result.data, accessKeyId = _result$data.accessKeyId, secretAccessKey = _result$data.secretAccessKey;

              _this.setState({
                isInstalled: true,
                credentials: {
                  id: accessKeyId,
                  secret: secretAccessKey
                },
                messageType: 'success',
                message: successMessage,
                isLoading: false
              });

              _context2.next = 15;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](4);

              _this.setState({
                isInstalled: false,
                messageType: 'error',
                message: errorMessage,
                isLoading: false
              });

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 12]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCopy", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(field) {
        var credentials, _credentials$field;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                credentials = _this.state.credentials;

                if (!(field && credentials)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 4;
                return (0, _clipboard.default)((_credentials$field = credentials[field]) !== null && _credentials$field !== void 0 ? _credentials$field : '');

              case 4:
                _this.setState({
                  message: messageMap[field],
                  messageType: 'success'
                });

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this.getNotificationConfigurations();

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setRequestState", function (requestState) {
      _this.setState({
        requestState: requestState
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getNotificationConfigurations", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
      var data, processedData;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return (0, _biConnectorUtils.fetchNotificationConfigurations)();

            case 3:
              data = _context5.sent;
              processedData = (0, _biConnectorUtils.processNotificationConfigurations)(data, _this.setRequestState);

              _this.setState({
                targets: processedData
              });

              _this.setState({
                notificationTabKey: 'notificationtab'
              });

              if (processedData.status === 'IN_PROGRESS') _this.setRequestState({
                type: 'info',
                title: 'Saving in Progress...',
                message: 'Please wait a moment before trying to save again.'
              });
              _context5.next = 14;
              break;

            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5["catch"](0);
              console.error(_context5.t0);

              _this.setRequestState({
                type: 'danger',
                title: 'Unable to Fetch Data',
                message: 'Please try again later. If issue persists, contact support'
              });

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 10]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(BiToolsConnector, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          isInstalled = _this$state.isInstalled,
          isLoading = _this$state.isLoading,
          messageType = _this$state.messageType,
          message = _this$state.message,
          activeTab = _this$state.activeTab,
          credentials = _this$state.credentials,
          showUninstallModal = _this$state.showUninstallModal;
      var awsAthenaData = {
        Host: this.props.Host,
        Port: this.props.Port,
        Database: this.props.Database,
        Region: this.props.Region,
        Catalog: this.props.Catalog,
        Workgroup: this.props.Workgroup,
        OutputLocation: this.props.OutputLocation,
        EncryptionOptions: this.props.EncryptionOptions,
        Server: this.props.Server
      };
      return (0, _preact.h)(_IntegrationSetup.default, {
        headerTitle: "Data Lake Connector",
        appLogoName: "data-lake-connector-l",
        appContainerBackgroundColor: "#CCE1FF",
        dismissMessage: this.dismissMessage,
        messageType: messageType,
        message: message,
        installButton: isInstalled ? (0, _preact.h)(_PanelItems.InstallAndUninstallButtons, {
          onClickUninstallButton: this.onClickUninstallButton
        }) : (0, _preact.h)(_Button.default, {
          size: "medium",
          variant: "brand",
          title: "Install now",
          className: "installation__button_cta",
          onClick: function onClick() {
            return _this2.setActiveTab(1);
          }
        }),
        description: (0, _preact.h)(_BiConnectorOverviewDescriptionText.default, null),
        tabTitles: ['Resources', 'Installation'].concat((0, _toConsumableArray2.default)(this.props.isNotificationEnabled ? ['Notifications'] : [])),
        activeTab: activeTab,
        onClickTab: function onClickTab(selectedTab) {
          return _this2.setActiveTab(selectedTab);
        },
        tabContents: [(0, _preact.h)(_Tabs.ResourcesTab, {
          key: "resourcesTab",
          isInstalled: isInstalled
        }), (0, _preact.h)(_Tabs.InstallationTab, {
          key: "installationTab",
          credentials: credentials,
          isInstalled: isInstalled,
          isLoading: isLoading,
          onClickCopy: this.handleCopy,
          onClickUninstall: this.onClickUninstallButton,
          onGenerateAccessKeys: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
            return _regenerator.default.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return _this2.onGenerateAccessKeys();

                  case 2:
                    return _context6.abrupt("return", _context6.sent);

                  case 3:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6);
          })),
          awsAthenaData: awsAthenaData
        })].concat((0, _toConsumableArray2.default)(this.props.isNotificationEnabled ? [(0, _preact.h)(_NotificationsTab.default, {
          key: this.state.notificationTabKey,
          targets: this.state.targets,
          requestState: this.state.requestState,
          setRequestState: this.setRequestState
        })] : [])),
        uninstallModal: (0, _preact.h)(_UninstallModal.default, {
          headerTitle: "BI Connector",
          onUninstall: this.onUninstall,
          showUninstallModal: showUninstallModal,
          closeUninstallModal: this.closeUninstallModal,
          enabledIntegrationCount: 0
        })
      });
    }
  }]);
  return BiToolsConnector;
}(_preact.Component);

var _default = BiToolsConnector;
exports.default = _default;